<template>
    <div id="personalCenter">

         <div class="section1">
<!--            <h4>个人信息</h4> -->
            <el-row>
                <el-col :span="8">
                    <i class="fa fa-product-hunt" style="font-size: 12px;"></i>&nbsp;&nbsp;<label style="width:120px;">昵 称：</label>{{personalData.name}}
                </el-col>
            </el-row> 
            <br/>
            <el-row> 
                <el-col :span="16">
                    <i class="fa fa-mobile " style="font-size: 20px;"></i>&nbsp;&nbsp;<label style="width:120px;">手机号：</label>
                    <span style="width:120px;display: inline-block;">{{personalData.bindMobile}} </span>
                    <div style="width:170px;display: inline-block;text-align: right;">
                        <el-button type="primary" plain @click="resetMobiledialog = true">重绑手机</el-button>
                    </div>
                </el-col>
            </el-row> 
            <br/>
             <el-row> 
                <el-col :span="16">
                    <i class="fa fa-mobile " style="font-size: 20px;"></i>&nbsp;&nbsp;<label style="width:120px;">佣金余额：</label>
                      <span style="width:120px;display: inline-block;">{{yongjing}}  / 元</span>
                    <div style="width:170px;display: inline-block;text-align: right;">
                        <el-button type="success" plain @click="appliyRmb()">佣金提现</el-button>
                    </div>
                </el-col>
            </el-row> 
            
            <br/>
             <el-row> 
                <el-col :span="16">
                    <i class="fa fa-mobile " style="font-size: 20px;"></i>&nbsp;&nbsp;<label style="width:120px;">号卡佣金：</label>
                      <span style="width:120px;display: inline-block;">{{haokaPrice}}  / 元</span>
                    <div style="width:170px;display: inline-block;text-align: right;">
                        <el-button type="success" plain @click="appliyRmbHaoka()">号卡提现</el-button>
                    </div>
                </el-col>
            </el-row> 

            <br/>
             <el-row> 
                <el-col :span="16">
                    <i class="fa fa-mobile " style="font-size: 20px;"></i>&nbsp;&nbsp;<label style="width:120px;">预充值余额：</label>
                      <span style="width:120px;display: inline-block;">{{yuchongzhi}} / 元 </span>
                    <div style="width:170px;display: inline-block;text-align: right;">
                        <el-button type="danger" plain @click="appliyRmbs()">余额预警</el-button>
                        <el-button type="success" plain @click="inevntYucun()">充值预存</el-button>
                    </div>
                </el-col>
            </el-row> 

             <br/>
               <br/>
                 <br/>
                   <br/>
            <el-row>
                <el-button type="success" plain  @click="modifyPwdVisible = true">修改登录密码</el-button>
                <!-- <el-button type="success" plain  @click="changePaypassDialog=true">修改提现密码</el-button> -->
            </el-row> 

        </div>

        <!-- 重绑手机号 -->
        <el-dialog :append-to-body="true"  title="重绑手机号" :visible.sync="resetMobiledialog"  width="600px" @close="cancelResetMobile()" :close-on-click-modal="false">
            <el-form ref="resetMobileForm" :model="resetMobileForm"  :rules="resetMobileRules" label-width="100px">

                <el-form-item label="新手机号"  prop="resetMobile">
                    <el-input  style="width:45%" v-model="resetMobileForm.resetMobile" ></el-input>
                    <!-- <el-button  type="primary" :disabled="resetMobileSmsFlag" @click="getSmsCode('resetMobile')" style="width:30%; float: right;">
                        {{resetMobileBtnTxt}}
                    </el-button> -->
                </el-form-item>

                <el-form-item label="登录密码"  prop="smsCode" >
                    <el-input v-model="resetMobileForm.smsCode"  show-password clearable style="width:45%"></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelResetMobile()">取 消</el-button>
                <el-button type="primary" @click="doRetsetMobile()">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 重绑手机号  end -->



        <!-- 修改提现配置 -->
        <el-dialog :append-to-body="true"  title="编辑提现配置" :visible.sync="editWithdrawalConfigDialog"  width="600px" @close="cancelEditWithdrawalConfig()" :close-on-click-modal="false">
            <el-form ref="editWithdrawalConfigForm" :model="editWithdrawalConfigForm" :rules="editWithdrawalConfigRules" label-width="120px">
                <el-form-item label="提现方式：">
                    <el-radio-group v-model="editWithdrawalConfigForm.cashType">
                        <el-radio :label="1">支付宝</el-radio>
                        <!-- <el-radio :label="2">银行卡</el-radio> -->
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="支付宝名称：" prop="bankName">
                    <el-input v-model="editWithdrawalConfigForm.bankName"  clearable></el-input>
                </el-form-item>

                <el-form-item label="支付宝账号：" prop="payeeAccount">
                    <el-input v-model="editWithdrawalConfigForm.payeeAccount"  clearable></el-input>
                </el-form-item>
                
                <el-form-item label="收款人姓名："  prop="payeeName">
                    <el-input v-model="editWithdrawalConfigForm.payeeName"  clearable></el-input>
                </el-form-item>

                <el-form-item label="收款人手机号：" prop="mobile">
                    <el-input v-model="editWithdrawalConfigForm.mobile"  clearable></el-input>
                </el-form-item>

                <el-form-item label="当前状态：" >
                    <el-radio-group v-model="editWithdrawalConfigForm.enable">
                        <el-radio :label="0">禁用</el-radio>
                        <el-radio :label="1">启用</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelEditWithdrawalConfig()">取 消</el-button>
                <el-button type="primary" @click="doSaveWithdrawalConfig()">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 修改提现配置  end -->



        <!-- 修改登录密码 -->
        <el-dialog :append-to-body="true"  title="修改密码" :visible.sync="modifyPwdVisible"  width="600px" @close="cancelModifyPwd()" :close-on-click-modal="false">
            <el-form ref="modifyPwdForm" :model="modifyPwdForm" :rules="pwdRules" label-width="100px">
                <el-form-item label="原密码：" prop="oldPwd">
                    <el-input v-model="modifyPwdForm.oldPwd" show-password clearable></el-input>
                </el-form-item>
                <el-form-item label="新密码：" prop="newPwd">
                    <el-input v-model="modifyPwdForm.newPwd" show-password clearable></el-input>
                </el-form-item>
                <el-form-item label="确认密码：" prop="newPwdAgain"> 
                    <el-input v-model="modifyPwdForm.newPwdAgain" show-password clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelModifyPwd()">取 消</el-button>
                <el-button type="primary" @click="modifyPwd">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 修改登录密码  end -->


        <!-- 代理商修改支付/提现密码 -->
        <el-dialog :append-to-body="true"  title="修改提现密码" :visible.sync="changePaypassDialog"  width="600px" @close="cancelToChangePaypass()" :close-on-click-modal="false">
            <el-form :model="changePaypassForm" ref="changePaypassForm" :rules="changePaypassRules" label-width="120px" >
                <el-form-item  label="提现密码" prop="paypass" >
                    <el-input v-model="changePaypassForm.paypass" show-password clearable></el-input>
                </el-form-item>

                <el-form-item  label="再次确认密码" prop="confirmPaypass">
                    <el-input v-model="changePaypassForm.confirmPaypass" show-password clearable></el-input>
                </el-form-item>

                <!-- <el-form-item label="手机号"  prop="userPhone">
                    <el-input  style="width:65%" v-model="changePaypassForm.userPhone" disabled></el-input>
                    <el-button  type="primary" :disabled="smsFlag" @click="getSmsCode('changePaypass')" style="width:30%; float: right;">{{changePasswordBtnTxt}}</el-button>
                </el-form-item>
                    -->
                <el-form-item label="登录密码"  prop="smsCode">
                    <el-input v-model="changePaypassForm.smsCode" show-password clearable></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelToChangePaypass()">取 消</el-button>
                <el-button type="primary" @click="doChangePaypass()">确 定</el-button>
            </span>
        </el-dialog> 

        <el-dialog :append-to-body="true"  title="提现申请" :visible.sync="applyVisible"  width="500px" @close="cancelToApply()" :close-on-click-modal="false">

            <el-form  ref="withdrawalForm" :model="withdrawalForm" label-width="100px" label-position="left" >
                <!-- <el-form-item label="收款账户：" >
                    <el-select v-model="withdrawalForm.withdrawalId" placeholder="请在系统右上角 个人中心 创建">
                        <el-option
                          v-for="item in withdrawalOptions"
                          :key="item.id"
                          :label="item.cashType==1?'支付宝 - '+item.payeeAccount:'银行卡 - '+item.payeeAccount"
                          :value="item.id">
                        </el-option>
                    </el-select> 
                </el-form-item> -->
                 <el-form-item style="margin-top: 25px;" label="收款人姓名:" >
                    <el-input placeholder="收款人姓名" v-model="withdrawalForm.backName"></el-input>
                </el-form-item>
                <el-form-item style="margin-top: 25px;" label="支付宝账户：" >
                    <el-input placeholder="支付宝账户" v-model="withdrawalForm.wxPhone"></el-input>
                </el-form-item>
                <p style="color:red">备注:收款人姓名和支付宝实名认证姓名一致，不然无法打款。</p>
                <el-form-item style="margin-top: 25px;" label="提现金额：" >
                    <el-input placeholder="请输入提现金额" v-model="input1" v-model.trim="withdrawalForm.priceRmb" @keyup="formatPrice()" 
                        @blur="formatPrice()">
                        <template slot="prepend">￥</template>
                        <template slot="append">元</template>
                    </el-input>
                </el-form-item>

                <!-- <el-form-item style="margin-top: 25px;" label="提现密码：" >
                    <el-input placeholder="请输入密码" v-model="withdrawalForm.paypass" show-password></el-input>
                </el-form-item> -->

            </el-form>

            <p style="margin-top: 10px; margin-bottom: 50px;color: #606266;">
            最小提现金额{{cashoutMinAmount}}元，单笔提现手续费率百分之{{cashoutFee}}</p>
            <!-- <el-button @click="withdrawalForm.priceRmb = allBalanceRmb">全部提现</el-button> -->
            <el-button @click="cancelToApply()">取 消</el-button>
            <el-button type="primary" @click="applyCashOutHandler()">提 现</el-button>
        </el-dialog> 

      <el-dialog :append-to-body="true"  title="预警配置" :visible.sync="applyVisibles"  width="500px" @close="cancelToApply()" :close-on-click-modal="false">

            <el-form  ref="agentInfos" :model="agentInfos" label-width="100px" label-position="left" >
                <el-form-item style="margin-top: 25px;" label="预警金额：" >
                    <el-input placeholder="预警金额为0时 将自动取消预警" v-model.trim="agentInfos.idCard" @keyup="formatPrice()" 
                        @blur="formatPrice()">
                        <template slot="prepend">￥</template>
                        <template slot="append">元</template>
                    </el-input>
                </el-form-item>

                <el-form-item style="margin-top: 25px;" label="通知手机号：" >
                    <el-input placeholder="通知手机号" v-model="agentInfos.bindMobile"></el-input>
                </el-form-item>
            </el-form>
            <p style="margin-top: 10px; margin-bottom: 50px;color: red;">
              配置后，系统将会在您预存不足时 发送短信提醒通知！(预警金额为0时 将自动取消预警)</p>
            <el-button @click="cancelToApply()">取 消</el-button>
            <el-button type="primary" @click="applyCashOutHandlers()">配 置</el-button>
        </el-dialog> 
 <el-dialog :append-to-body="true"  title="支付宝充值" :visible.sync="lsPayVisible"  width="400px" @close="cancelToPay" :close-on-click-modal="false">
            <div class="AliPayIcon">
                <div>
                   <img src="@/assets/1alipay.png"> 
                </div>
            </div>
            <p>充值金额（元）</p>
            <div class="priceDiv">
                <span class="priceIcon">￥</span>
                <input class="priceRmbInput"  v-model.trim="priceRmb" 
                @keyup="formatPrice()" 
                @blur="formatPrice()" 
                placeholder="请输入充值金额">
            </div>
            <div class="topUpBtn" @click="doAddOrdersss">充 值</div>
            
        </el-dialog> 
         <el-dialog :append-to-body="true"  title="充值预存款" :visible.sync="shareImgs" width="600px" @close="cancel" :close-on-click-modal="false">
                
                   
            <div style="text-align: center; width: 500px; border: ">               
               <img  :src="getImgUrl() +  addOrEditPkgForm.shareImg" alt="" width="300px" height="300px" style="margin: 0 auto;">  
            </div>
            <p style="color:red">支付完完成后 点击确定刷新页面即可</p>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="cancel">确 定</el-button>
            </div>            

        </el-dialog>
        
        <el-dialog :append-to-body="true"  title="微信充值" :visible.sync="AliPayVisible"  width="400px" @close="cancelToPay" :close-on-click-modal="false">
            <div class="AliPayIcon">
                <div>
                   <img src="@/assets/alipay.png"> 
                </div>
            </div>
            <p>充值金额（元）</p>
            <div class="priceDiv">
                <span class="priceIcon">￥</span>
                <input class="priceRmbInput"  v-model.trim="priceRmb" 
                @keyup="formatPrice()" 
                @blur="formatPrice()" 
                placeholder="请输入充值金额">
            </div>
            <div class="topUpBtn" @click="doAddOrders">充 值</div>
            
        </el-dialog> 
    </div>
</template>
<script>
import {getPrechargeOrderList, addPrechargeOrder, alipayParam,addPrechargeOrderWx,lspayParam} from '@/api/order.js'
import {getAgentAccount, getAccountData} from '@/api/home.js'
import common from '@/utils/common.js'
import {applyCashOut } from '@/api/finance.js';
import {mapGetters } from "vuex";
export default {
    data(){
        let checkPwd = (rule, value, callback) => {
            if(value != this.modifyPwdForm.newPwd){
                return callback(new Error('两次输入密码不一致'))
            }
            callback();
        };

        let checkConfirmPaypass = (rule, value, callback) => {
            if(value != this.changePaypassForm.paypass){
                return callback(new Error('两次输入密码不一致'))
            }
            callback();
        };

        let checkBindPhone = (rule, value, callback) => {
            let pattern = new RegExp("[0-9]+");
            if(!pattern.test(value) || value.indexOf("1")!=0 || value.length!=11){
                return callback(new Error('请输入正确的手机号码'))
            }
            callback();
        };

        let checkSmsCode = (rule, value, callback) => {
            let pattern = new RegExp("[0-9]+");
            if(!pattern.test(value)){
                return callback(new Error('请输入正确的验证码'))
            }
            callback();
        };

        return {
            isAgent: localStorage.getItem('agentId') != 'null' && localStorage.getItem('agentId') != "",
            personalData:{
                name: null,
                accountName: null,
                bindMobile: null,
                pathNames: null,
            },
             withdrawalForm:{
                withdrawalId: null,
                priceRmb: '',
                paypass:null,
                wxPhone:'',
                backName:''
            },
               agentInfos:{
                idCard:'',
                bankName:'',
                bindMobile:''
            },
            lsPayVisible:false,
            AliPayVisible:false,

            //重绑手机号码
            resetMobiledialog: false,
            resetMobileForm:{
                resetMobile: null,
                smsCode: null,
            },
            resetMobileRules: {
                resetMobile: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { validator: checkBindPhone, trigger: 'blur' }
                ],
                smsCode: [
                    { required: true, message: '请输入登录密码', trigger: 'blur' }
                ]
            },
            resetMobileBtnTxt: '获取验证码',
            //重绑手机号码 end

            /**  提现配置  **/
            withdrawalConfigData: [],
            editWithdrawalConfigDialog: false,
            editWithdrawalConfigForm:{
                id: null,
                bankName: null,
                enable: 1,
                mobile: null,
                payeeAccount: null,
                payeeName: null,
                cashType: 1,
            },
            shareImgs:false,
              addOrEditPkgForm: {
                shopImgss:'',
                shopHeadImgs:'',
                state:'',
                pkgName:'',
                shopImgs: '',
                shopState: '',
                name:'',
                nameUrl:'',
                supplierName:'',
                account:'',
                pwd:'',
                pwdkey:'11',
                shareImg:'',
                shopInfo:''
                         
            },
            editWithdrawalConfigRules:{
                bankName: { required: true, message: '请输入银行名称', trigger: 'blur' },
                mobile: { required: true, message: '请输入手机号', trigger: 'blur' },
                payeeAccount: { required: true, message: '请输入收款账号', trigger: 'blur' },
                payeeName: { required: true, message: '请输入收款人姓名', trigger: 'blur' },
            },
            /**  提现配置  end **/

            /** 修改登录密码  **/
            modifyPwdVisible:false,
            modifyPwdForm: {
                id: '',
                oldPwd: '',
                newPwd: '',
                newPwdAgain: ''
            },
            pwdRules: {
                newPwd: [
                    { required: true, message: '必填项', trigger: 'blur' }
                ],
                oldPwd: [
                    { required: true, message: '必填项', trigger: 'blur' }
                ],
                newPwdAgain: [
                    { required: true, message: '必填项', trigger: 'blur' }
                ],
            },
            /** 修改登录密码 end  **/
            
            applyVisible:false,
            doAddOrder:false,
            cashoutMinAmount:0,
            cashoutFee:0,
            haoka:'',
            yongjing:0,
            haokaPrice:0,
            applyVisibles:false,
            yuchongzhi:0,
            priceRmb:'',
            //修改提现密码
            changePaypassDialog: false,
            changePasswordBtnTxt: '获取验证码',
            changePaypassForm:{
                paypass: null,
                confirmPaypass: null,
                userPhone: null,
                smsCode: null,
            },
            changePaypassRules: {
                paypass: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
                ],
                confirmPaypass:[
                    { required: true, message: '请再次确认密码', trigger: 'blur' },
                    { validator: checkConfirmPaypass, trigger: 'blur' }
                ],
                bindMobile: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { validator: checkBindPhone, trigger: 'blur' }
                ],
                smsCode: [
                    { required: true, message: '请输入登录密码', trigger: 'blur' },
                    { validator: checkSmsCode, trigger: 'blur' }
                ],
                 innerVisible:false,
            },
            //修改提现密码  end

        }

    },
    methods: {
          //微信支付
          doAddOrders(){
            let data = {
                priceRmb:this.priceRmb,
            }
             common.sysRequest('bindPhone/buy/sim/price', {}, 'post').then(res => {
                if(res.data.code == 200){
                    let result =res.data.data;
                     let sale =this.priceRmb*result.invent;
                 this.$confirm("本次充值手续费需要"+sale+"元，确定要充值吗？", "温馨提示" ,{          
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                
            addPrechargeOrderWx(data).then(res => {
                if (res.data.code == 200) {
                     this.addOrEditPkgForm.shareImg=res.data.data.img;
                    this.shareImgs=true;
                }else{
                    this.$message.error(res.data.message);
                    
                }

               // this.priceRmb = '';
             //   this.AliPayVisible = false;
            })
            }).catch(() => {
                
            });
                }
            })


        },
         cancel(){
            this.shareImgs=false;
            this.lsPayVisible=false;
            this.AliPayVisible = false;
            this.getAgentAccountHandler();
        },
         doAddOrdersss(){
            let data = {
                priceRmb:this.priceRmb,
            }
            addPrechargeOrder(data).then(res => {
                if (res.data.code == 200) {
                    let fm = new FormData();
                    fm.append("id", res.data.data.id);
                    lspayParam(fm).then(newres => {
                        if (newres.data.code == 200) {
                             this.addOrEditPkgForm.shareImg=newres.data.data.img;
                           this.shareImgs=true;
                        }
                    })
                }else{
                    this.$message.error(res.data.message);
                    
                }

                this.priceRmb = '';
            })
        },
          cancelToPay(){
            this.priceRmb = '';
            this.lsPayVisible = false;
            this.shareImgs=false;
            this.AliPayVisible=false;
        },
        inevntYucun(){

            //   common.sysRequest('app/wx/get/pay/state',{}, 'post').then(res => {  
            // if(res.data.code == 200){
            //     this.lsPayVisible=true;
            //  }else{
            //       this.AliPayVisible=true;      
            //         }
            //  });
            this.AliPayVisible=true;      
        },
        applyCashOutHandlers(){
  common.sysRequest('agent/update/yucun/data', this.agentInfos, 'post').then(res => {  
            if(res.data.code == 200){
              this.$message.success(res.data.message);
            }else{
                        this.$message.error(res.data.message);
                    }
        });
         this.applyVisibles=false;
        },
        appliyRmbs(){
                common.sysRequest('agent/select/yucun/data', {}, 'post').then(res => {  
            if(res.data.code == 200){
                this.agentInfos=res.data.data;
            }else{
                        this.$message.error(res.data.message);
                    }
        });
         this.applyVisibles=true;
     
    },
        formatPrice(){
            this.withdrawalForm.priceRmb = this.withdrawalForm.priceRmb.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');
        },
          cancelToApply(){
            this.withdrawalForm.priceRmb = '';
            this.withdrawalForm.paypass = "";
            this.applyVisible = false;
            this.applyVisibles = false;
        },
         appliyRmb(){
             this.haoka=0;
              this.applyVisible=true;
          },
             applyCashOutHandler(){
            if(Number(this.withdrawalForm.priceRmb) <= 0){
                this.$message.error('请输入提现金额');
                return;
            }
            if(this.withdrawalForm.backName==null || this.withdrawalForm.backName==''){
                  this.$message.error('请输入提现姓名');
                return;
            }
            let data = {"priceRmb":Number(this.withdrawalForm.priceRmb),
                        "withdrawalId": this.withdrawalForm.withdrawalId,
                        "paypass": this.withdrawalForm.paypass,
                        "wxPhone":this.withdrawalForm.wxPhone,
                        "backName":this.withdrawalForm.backName
                        }

            this.$confirm('确定要提现吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                applyCashOut(data).then(res => {
                    if(res.data.code == 200){
                        this.$message.success(res.data.message);
                        this.getAgentAccountHandler();
                        this.cancelToApply();
                    }else{
                        this.$message.error(res.data.message);
                    }
                    
                })
            }).catch(() => {

            });
        },
         appliyRmbHaoka(){
              this.haoka=1;
              this.applyVisible=true;
          },
             applyCashOutHandler(){
            if(Number(this.withdrawalForm.priceRmb) <= 0){
                this.$message.error('请输入提现金额');
                return;
            }
            if(this.withdrawalForm.backName==null || this.withdrawalForm.backName==''){
                  this.$message.error('请输入提现姓名');
                return;
            }
            let data ={};
            if(this.haoka==1){
                 data= {"priceRmb":Number(this.withdrawalForm.priceRmb),
                        "withdrawalId": this.withdrawalForm.withdrawalId,
                        "paypass": this.withdrawalForm.paypass,
                        "wxPhone":this.withdrawalForm.wxPhone,
                        "haoka":  this.haoka,
                        "backName":this.withdrawalForm.backName
                        }
            }else{
                 data= {"priceRmb":Number(this.withdrawalForm.priceRmb),
                        "withdrawalId": this.withdrawalForm.withdrawalId,
                        "paypass": this.withdrawalForm.paypass,
                        "wxPhone":this.withdrawalForm.wxPhone,
                        "backName":this.withdrawalForm.backName
                        }
            }

            this.$confirm('确定要提现吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                applyCashOut(data).then(res => {
                    if(res.data.code == 200){
                        this.$message.success(res.data.message);
                        this.getAgentAccountHandler();
                        this.cancelToApply();
                    }else{
                        this.$message.error(res.data.message);
                    }
                    
                })
            }).catch(() => {

            });
        },
        /**  重绑手机号码  **/
        cancelResetMobile(){
            this.resetMobileForm.resetMobile = '';
            this.resetMobiledialog = false;
        },
        doRetsetMobile(){
            this.$refs.resetMobileForm.validate(valid => {
                if(valid) {
                    let data = {
                        bindMobile: this.resetMobileForm.resetMobile,
                         paypass: this.resetMobileForm.smsCode,
                    }
                    common.sysRequest('agent/agent/mdy/info', data, 'post').then(res=>{
                        if(res.data.code == 200){
                            this.personalData.bindMobile = this.resetMobileForm.resetMobile;
                            this.changePaypassForm.userPhone = this.resetMobileForm.resetMobile;
                            this.$message.success(res.data.message);
                            this.cancelResetMobile();
                        }
                        else{
                            this.$message.error(res.data.message);
                        }
                        
                    });
                }
            });
        },
        /**  重绑手机号码  end **/


        /**  修改提现配置  end **/
        showEditWithdrawalConfig(config){
            if(config){
                for(let key in this.editWithdrawalConfigForm){
                    this.editWithdrawalConfigForm[key] = config[key];
                }

                this.editWithdrawalConfigForm.enable = config.enable?1:0;
            }
            this.editWithdrawalConfigDialog = true;
        },
        cancelEditWithdrawalConfig(){
            for(let key in this.editWithdrawalConfigForm){
                this.editWithdrawalConfigForm[key] = null;
            }
            this.editWithdrawalConfigDialog = false;
        },
        doSaveWithdrawalConfig(){
            this.$refs.editWithdrawalConfigForm.validate(valid => {
                if(valid) {
                    let path = 'agent/withdrawal/add';
                    if(this.editWithdrawalConfigForm.id != null){
                        path = 'agent/withdrawal/update'
                    }
                    common.sysRequest(path, this.editWithdrawalConfigForm, 'post').then(res=>{
                        if(res.data.code == 200){
                            this.$message.success(res.data.message);
                            this.cancelEditWithdrawalConfig();
                            this.getWithdrawalList();
                        }
                        else{
                            this.$message.error(res.data.message);
                        }
                    });
                }
            });
        },
        deleteWithdrawalConfig(id){
            this.$confirm('确定要删除此配置吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
                common.sysRequest('agent/withdrawal/delete/'+id, null, 'get').then(res=>{
                    if(res.data.code == 200){
                        this.getWithdrawalList();
                        this.$message.success(res.data.message);
                    }
                    else{
                        this.$message.error(res.data.message);
                    }
                });
            }).catch(() => {
      
            });
        },
        /**  修改提现配置  end **/


        /**  修改登录密码  **/
        cancelModifyPwd(){
            for(var key in this.modifyPwdForm){
                this.modifyPwdForm[key] = '';
            }
            this.$refs['modifyPwdForm'].resetFields();
            this.modifyPwdVisible = false;
        },
        
        getAgentAccountHandler(){
            getAgentAccount({}).then(res => {
                if(res.data.code == 200){
                    this.tableData = res.data.data.resultList;

                    for(let i=0; i<res.data.data.resultList.length; i++){
                        if(res.data.data.resultList[i].type==10){
                            this.yongjing = res.data.data.resultList[i].balanceRmb;
                        }else  if(res.data.data.resultList[i].type==20){
                            this.yuchongzhi = res.data.data.resultList[i].balanceRmb;
                        }else  if(res.data.data.resultList[i].type==30){
                            this.haokaPrice = res.data.data.resultList[i].balanceRmb;
                        }
                    }

                }else{
                    this.$message.error(res.data.message);
                }
            })

            
        },
        modifyPwd(){
            this.$refs.modifyPwdForm.validate(valid => {
                if(valid) {
                    if(this.modifyPwdForm.newPwd != this.modifyPwdForm.newPwdAgain){
                        this.$message.error("两次输入的新密码不一致！");
                        return ;
                    }
                    this.modifyPwdForm.id = localStorage.getItem("id");
                    common.sysRequest('sysUser/updatePwd', this.modifyPwdForm, 'post').then(res => {  
                        let code = res.data.code;
                        if(code == 200){
                            this.$message.success('密码修改成功,请重新登录!');
                            let _self = this;
                            setTimeout(function(){
                                _self.$router.push('/');
                            }, 1000);
                        }else{
                            this.$message.error(res.data.message)
                        }
                        this.modifyPwdVisible = false;
                    })                    
                }
            })
        },
        /**  修改登录密码  end**/


        /**  修改提现密码  **/
        getSmsCode(actionName){
            if(actionName=="changePaypass"){
                common.sysRequest('/sms/send', {userPhone:this.changePaypassForm.userPhone}, 'post').then(res => {  
                    if(res.data.code == 200){
                        var n = 60;
                        this.changePasswordBtnTxt = n +'s后重新获取';
                        let timer = window.setInterval(() => {   
                            n--;                     
                            this.changePasswordBtnTxt = n +'s后重新获取';
                            if(n < 1){
                                window.clearInterval(timer);
                                this.changePasswordBtnTxt = '获取验证码';
                            }
                        },1000)
                    }else{
                        this.$message.error(res.data.message);
                    }
                })
            }
            else if(actionName=="resetMobile"){
                common.sysRequest('/sms/send', {userPhone:this.resetMobileForm.resetMobile}, 'post').then(res => {  
                    if(res.data.code == 200){
                        var n = 60;
                        this.resetMobileBtnTxt = n +'s后重新获取';
                        let timer = window.setInterval(() => {   
                            n--;                     
                            this.resetMobileBtnTxt = n +'s后重新获取';
                            if(n < 1){
                                window.clearInterval(timer);
                                this.resetMobileBtnTxt = '获取验证码';
                            }
                        },1000)
                    }else{
                        this.$message.error(res.data.message);
                    }
                })
            }
            
        },
        doChangePaypass(){
            this.$refs.changePaypassForm.validate(valid => {
                if(valid) {
                    let data = this.changePaypassForm;
                    data.bindMobile = this.changePaypassForm.userPhone;
                    data.paypass=this.changePaypassForm.paypass;
                    common.sysRequest('/agent/agent/mdy/paypass', data, 'post').then(res=>{
                        if(res.data.code == 200){
                            this.$message.success(res.data.message);
                            this.cancelToChangePaypass();
                        }
                        else{
                            this.$message.error(res.data.message);
                        }
                        
                    });
                }
            });
        },

        cancelToChangePaypass(){
            for(let key in this.changePaypassForm){
                this.changePaypassForm[key] = null;
            }
            this.changePaypassForm.userPhone = this.personalData.bindMobile;
            this.changePaypassDialog = false;
        },
        /** 修改提现密码 end **/

        //获取提现配置列表
        getWithdrawalList(){
            common.sysRequest('agent/withdrawal/list', {}, 'post').then(res => {  
                if(res.data.code == 200){
                    this.withdrawalConfigData = res.data.data;
                }else{
                    this.$message.error(res.data.message);
                }
            });
        },
    },
    created(){
    this.getAgentAccountHandler();
        //获取用户信息
		console.log("获取用户信息");
        if(localStorage.getItem('agentId')!='null' && localStorage.getItem('agentId')!=''){
            common.sysRequest('agent/agent/info', null, 'get').then(res => {  
                if(res.data.code == 200){
                    this.personalData = res.data.data;
                    this.modifyPwdForm.id = res.data.data.id;
                    this.changePaypassForm.userPhone = res.data.data.bindMobile;
                }else{
                    this.$message.error(res.data.message);
                }
            });
        }
          common.sysRequest('agent/account/cashout/config', null, 'post').then(res => {
            if(res.data.code == 200){
                this.cashoutMinAmount = res.data.data.cashoutMinAmount;
                this.cashoutFee = res.data.data.cashoutFee;
            }
        });
        
        this.getWithdrawalList();
    },

    computed: {
        resetMobileSmsFlag(){
            if(this.resetMobileForm.resetMobile && this.resetMobileForm.resetMobile.length == 11 && this.resetMobileBtnTxt == '获取验证码'){
                return false;
            }else{
                return true;
            }
        },

        smsFlag(){
            if(this.changePaypassForm.userPhone && this.changePaypassForm.userPhone.length == 11 && this.changePasswordBtnTxt == '获取验证码'){
                return false;
            }else{
                return true;
            }
        },

        ...mapGetters("menu", {
            hasAuthority: "hasAuthority" 
        }),

    },

}
</script>
<style lang="less" scoped>
    .AliPayIcon{
        div{
            width:200px;
            margin: 0 auto;
            margin-bottom: 30px;

            img{ width: 100%;}
        }
    }
     .topUpBtn{
        display: inline-block;
        width: 100%;
        height: 35px;
        line-height: 35px;
        text-align: center;
        border-radius: 5px;
        color: #fff;
        background: #3a8ee6;
    }
    
    .priceDiv{
        margin-top: 20px;
        margin-bottom:50px;
        display: flex;

        .priceIcon{
            display: inline-block;
            flex: 1;
            height:35px;
            width:50px;
            line-height:35px;
            font-size:24px;
            border-bottom:1px solid #000;
            text-align: center;
        }

        .priceRmbInput{
            line-height:35px;
            flex: 5;
            height:35px;
            font-size: 28px;
            outline:none;
            border: none;
            border-bottom: 1px solid #000;
        }

        input:-ms-input-placeholder {
            font-size: 14px;
        }

        input::-moz-input-placeholder {
            font-size: 14px;
        }

        input::-webkit-input-placeholder {
            font-size: 14px;
        }

        input:-moz-placeholder{font-size: 14px;}                 
        input::-moz-placeholder{font-size: 14px;}                
        input:-ms-input-placeholder{font-size: 14px;}  

    }
#personalCenter {
    
    .section1{
        margin-left: 10px;

        h4 {
            font-size: 14px;
            font-weight: bold;
            padding-left: 5px;
            margin-top: 45px;
            margin-bottom: 20px;
            margin-left: -8px;
            border-left: 3px solid #409eff;            
        }

        >h4:first-child{
            margin-top: 0px;
        }

        label{
            display:inline-block;
        }
        .el-row{
            margin-bottom: 20px;
        }
        span{
            text-align:left;
        }
    }
}
</style>
